import { BASE_URL, DO_NOT_ORDER_LIST_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { ADD_DNO_ITEMS_FAILURE, ADD_DNO_ITEMS_REQUEST, ADD_DNO_ITEMS_RESET, ADD_DNO_ITEMS_SUCCESS } from "./action-type"
import { Post } from "services/apiService";

export const addDoNotOrderItemsAction = (payload) => {
    return (dispatch) => {
        dispatch(addDoNotOrderItemsRequest());
        let apiUrl = `${BASE_URL}${DO_NOT_ORDER_LIST_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload
        };
        
        Post(request)
            .then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                    dispatch(addDoNotOrderItemsSuccess(response));
                } else {
                    dispatch(addDoNotOrderItemsFailure(response));
                }
            })
            .catch((err) => {
                dispatch(addDoNotOrderItemsFailure(err));
            });
    }
}

const addDoNotOrderItemsRequest = () => {
    return {
        type: ADD_DNO_ITEMS_REQUEST
    }
}

const addDoNotOrderItemsSuccess = (response) => {
    return {
        type: ADD_DNO_ITEMS_SUCCESS,
        addDNOResponse: response
    }
}

const addDoNotOrderItemsFailure = (error) => {
    return {
        type: ADD_DNO_ITEMS_FAILURE,
        addDNOResponse: error
    }
}

export const addDoNotOrderItemsReset = () => {
    return {
        type: ADD_DNO_ITEMS_RESET
    }
}